var map = {
	"./address.schema.json": 63365,
	"./authors.schema.json": 67139,
	"./dates.schema.json": 76510,
	"./extension-article.schema.json": 61339,
	"./extension-blog.schema.json": 57825,
	"./extension-collection.schema.json": 19925,
	"./extension-event.schema.json": 61391,
	"./extension-keyword.schema.json": 64285,
	"./extension-media.schema.json": 4841,
	"./extension-opinion.schema.json": 80010,
	"./extension-product.schema.json": 71779,
	"./image.schema.json": 44715,
	"./link.schema.json": 8478,
	"./playlist-medium.schema.json": 63935,
	"./playlist-player.schema.json": 37371,
	"./playlist.schema.json": 27460,
	"./teaser.schema.json": 44745,
	"./timestamp.schema.json": 87436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83811;